import { style, media } from 'typestyle'
import { important } from 'csx'
export const w100smi = style(media({ maxWidth: 576 }, { width: important('100%') }))
